import { createSupabaseEdgeFetch } from '@nexus/ari-lib/api/supabase-edge-fetch';
import { getAccessToken, resyncSession } from '@nexus/supabase';

import { getAuthBackendUrl } from '../config/global';

/**
 * Single ari-cloud-side handle for hitting Supabase Edge Functions under
 * `${SUPABASE_URL}/functions/v1/root/<endpoint>`. The lib factory owns the
 * fetch + Bearer + JSON-or-throw shape; we inject the access token here.
 */
export const supabaseEdgeFetch = createSupabaseEdgeFetch({
  baseUrl: getAuthBackendUrl(),
  getToken: async () => {
    const token = await getAccessToken();
    if (!token) throw new Error('No authenticated session');
    return token;
  },
  refreshToken: resyncSession,
});
